
import Input from '../../shared/input';
import { InputProperty, InputEventType, InputType } from '../../shared/input/enums';
import NumberInputProps from './mixins/NumberInputProps';
import { NumberInputProperty } from './enums';
import { ControlEventType } from '../../enums';
import { Locale } from '../../../../../enums';

const COMMA_REGEX = /,/g;
const NUMBER_CHAR_REGEX = /[^0-9.]/g;
const DOT_CHAR_REGEX = /(\..*?)\..*/g;
const DEFAULT_NUMBER_INPUT_VALUE = '';

export default {
  name: 'NumberInput',
  components: {
    Input,
  },
  mixins: [NumberInputProps],
  data() {
    return {
      InputProperty,
      InputEventType,
      InputType,
      NumberInputProperty,
    };
  },
  computed: {
    displayValue() {
      const value = this[NumberInputProperty.Value];

      return this.getDisplayValue(value);
    },
  },
  methods: {
    getDisplayValue(value) {
      if (!value) {
        return value || DEFAULT_NUMBER_INPUT_VALUE;
      }

      if (this[NumberInputProperty.HasThousandSeparator]) {
        return Number(value).toLocaleString(
          Locale.EnCA,
          { minimumFractionDigits: this.getNumberOfDecimalPlaces(value) },
        );
      }

      return value;
    },
    getValueFromDisplayValue(value) {
      if (this[NumberInputProperty.HasThousandSeparator]) {
        return parseFloat(`${value}`.replace(COMMA_REGEX, ''));
      }

      return value;
    },
    getNumberOfDecimalPlaces(value) {
      const valueAsNumber = Number(value);
      const isInteger = Math.floor(valueAsNumber) === valueAsNumber;

      if (isInteger) {
        return 0;
      }

      const [, decimalPlaces] = value.toString().split('.');

      return decimalPlaces?.length || 1;
    },
    getValidatedValueByRange(value) {
      if (!value) {
        return value;
      }

      const valueAsNumber = Number(value);
      const previousValue = this[NumberInputProperty.Value];

      if (valueAsNumber > this[NumberInputProperty.Max]) {
        return previousValue;
      }

      if (valueAsNumber < this[NumberInputProperty.Min]) {
        return previousValue;
      }

      return value;
    },
    getValidatedValueByRegex(value) {
      return `${value}`
        .replace(NUMBER_CHAR_REGEX, '')
        .replace(DOT_CHAR_REGEX, '$1');
    },
    handleInput(event) {
      const value = this.getValueFromDisplayValue(event.target.value);
      const validatedByRegexValue = this.getValidatedValueByRegex(value);
      const validatedByRangeAndRegexValue = this.getValidatedValueByRange(validatedByRegexValue);

      // eslint-disable-next-line
      event.target.value = validatedByRangeAndRegexValue
        && this.getDisplayValue(validatedByRangeAndRegexValue);

      this.$emit(
        ControlEventType.Change,
        validatedByRangeAndRegexValue && Number(validatedByRangeAndRegexValue),
      );
    },
    handleInputFocus(event) {
      this.$emit(ControlEventType.Focus, event.target.value);
    },
    handleInputBlur(event) {
      this.$emit(ControlEventType.Blur, event.target.value);
    },
  },
};
